export const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'SofChef',
  url: 'https://sofchef.com.br',
  logo: 'https://sofchef.com.br/images/Logo.png',
  sameAs: [
    'https://instagram.com/sofchef_brasil',
  ],
};

export const softwareApplicationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'SofChef',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Web, Windows',
  description:
    'Sistema de gestão para restaurantes e bares: cardápio digital, controle de mesas, caixa, equipe e emissão fiscal em um só lugar.',
  offers: {
    '@type': 'Offer',
    availability: 'https://schema.org/InStock',
    url: 'https://sofchef.com.br#pricing',
  },
};

export const buildFaqPageJsonLd = (categories) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: categories.map((category) => ({
    '@type': 'Question',
    name: category.title,
    acceptedAnswer: {
      '@type': 'Answer',
      text: category.description,
    },
  })),
});
